// extracted by mini-css-extract-plugin
export var label = "_f0-2";
export var slideContainer = "_f0-0";
export var slider = "_f0-1";